module.exports = "<app-video (click)=\"demoSwitch(false)\" [hidden]=\"!demoOn\"></app-video>\n<span on-mouseover='over()' [hidden]=\"demoOn\">\n    <div class=\"main-container\">\n        <app-nav [(getDemoStatus)]=\"demoOn\"></app-nav>\n        <router-outlet (deactivate)=\"onDeactivate()\"></router-outlet>\n    </div>\n    <app-footer></app-footer>\n</span>"


//////////////////
// WEBPACK FOOTER
// /var/www/ras.universarium.org/www/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1